import { computed } from 'mobx';

export default class ReportingTemplateHeaderModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = item.id;
    this.title1 = item.title1;
    this.title2 = item.title2;
    this.logo = item.logo;
    this.default = item.default;
  }

  @computed get asJson() {
    return {
      id: this.id,
      title1: this.title1,
      title2: this.title2,
      logo: this.logo,
      default: this.default,
    };
  }

  updateFromJson(json) {
    this.id = json.id;
    this.title1 = json.title1;
    this.title2 = json.title2;
    this.logo = json.logo;
    this.default = json.default;
  }
}



// WEBPACK FOOTER //
// ./src/models/SystemConfiguration/ReportingTemplateHeaderModel.js